import React from 'react';

import { createIcon } from '@chakra-ui/react';

/**
 * Artwork is inset to 18 of the 24 unit box — the mockup's 12px glyph in a 16px
 * icon — and centred on (12, 12), so it doesn't crowd the label it sits beside.
 */
export const TriangleTopIcon = createIcon({
  displayName: 'TriangleTopIcon',
  viewBox: '0 0 24 24',
  path: [
    <path
      key="triangle-top-icon"
      d="M5.5371 17.9983 H18.4643 L12.0006 5.0713 L5.5371 17.9983 Z"
      fill="currentColor"
    />,
  ],
});
